define(["react","prop-types","@bingads-webui-react/with-default-styles","underscore"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__10__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 89);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(90);


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UiBlocker", {
  enumerable: true,
  get: function get() {
    return _uiBlocker.UiBlocker;
  }
});

var _uiBlocker = __webpack_require__(91);

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiBlocker = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _withDefaultStyles = __webpack_require__(7);

var _getStyles = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UiBlockerUnthemed = props => {
  const blocking = props.blocking,
        children = props.children,
        loadingText = props.loadingText;
  const classes = blocking ? `${props.classes.reactBlockUi} react-block-ui` : 'react-block-ui-none';
  return _react.default.createElement("div", {
    className: classes,
    "aria-busy": blocking
  }, children, blocking && _react.default.createElement("div", {
    className: props.classes.blockUiContainer
  }, _react.default.createElement("div", {
    className: props.classes.blockUiOverlay
  }, _react.default.createElement("div", {
    className: props.classes.blockerIndicator,
    role: "status",
    "aria-label": loadingText
  }, _react.default.createElement("div", {
    className: "blocker-image"
  }), _react.default.createElement("div", {
    className: "blocker-text"
  }, loadingText)))));
};

UiBlockerUnthemed.propTypes = {
  blocking: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node.isRequired,
  loadingText: _propTypes.default.string.isRequired,
  classes: _propTypes.default.shape({
    reactBlockUi: _propTypes.default.string,
    blockUiContainer: _propTypes.default.string,
    blockUiOverlay: _propTypes.default.string,
    blockerIndicator: _propTypes.default.string
  }).isRequired
};
const UiBlocker = (0, _withDefaultStyles.withDefaultStyles)(UiBlockerUnthemed, _getStyles.getStyles);
exports.UiBlocker = UiBlocker;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getStyles = ({
  blockUi = {}
}, {
  color = {}
}) => {
  const defaultReactBlockUi = {
    position: 'relative',
    minHeight: '2em'
  };
  const defaultBlockUiContainer = {
    position: 'absolute',
    backgroundColor: 'rgba(51, 51, 51, 0.15)',
    zIndex: 1010,
    textAlign: 'center',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    minHeight: '2em',
    cursor: 'wait',
    overflow: 'hidden',
    '&:focus': {
      outline: 'none'
    }
  };
  const defaultBlockUiOverlay = {
    width: '100%',
    height: '100%'
  };
  const defaultBlockerIndicator = {
    marginTop: '-55px',
    padding: '20px',
    top: '45%',
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'white',
    maxWidth: '370px',
    minWidth: '140px',
    minHeight: '70px',
    zIndex: 1011,
    '&:hover &:focus': {
      border: {
        color: _underscore.default.result(color.light, 'dark30')
      }
    }
  };
  return {
    blockUiContainer: _underscore.default.extend(defaultBlockUiContainer, blockUi.blockUiContainer),
    reactBlockUi: _underscore.default.extend(defaultReactBlockUi, blockUi.reactBlockUi),
    blockUiOverlay: _underscore.default.extend(defaultBlockUiOverlay, blockUi.blockUiOverlay),
    blockerIndicator: _underscore.default.extend(defaultBlockerIndicator, blockUi.blockerIndicator)
  };
};

exports.getStyles = getStyles;

/***/ })

/******/ })});;
